import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import MultiSelect from "../../components/shared/MultiSelect";
import NormalButton from "../../components/shared/NormalButton";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import PageMain from "../../containers/shared/PageMain";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../../components/utils/apiClient";
import TextArea from "../../components/shared/TextArea";
import DateField from "../../components/shared/DateField";
import ModalContainer from "../../containers/shared/ModalContainer";
import Toast from "../../components/shared/Toast";


const PaymentRequestsEditPage = () => {

    const { id } = useParams();
    const {t,i18n} = useTranslation();
    useDocumentTitle('تعديل أمر دفع');
    const navigate = useNavigate();
    const pageTitle = {title: 'تعديل أمر دفع', subTitle: 'يمكنك تعديل أمر الدفع للمستفيدين من هنا.'};
    const [toast, setToast] = useState({show: false,type: null, message:'' });
    const EmptyEditPaymentRequestForm = {
        title: '',
        type: "rent",
        amount: '',
        createdBy: {},
        description: '',
        beneficiaryIds: [],
        dueDate: '',
        isRecurring: '',
        recurrence: {
            frequency: "",
            repeat: ""
        }
    };
    const [editPaymentRequestForm,setEditPaymentRequestForm] = useState(EmptyEditPaymentRequestForm);
    const [errors, setErrors] = useState(null);
    const [isEditPaymentRequestFormDisabled, setIsEditPaymentRequestFormDisabled] = useState(true);

    const [allUsers, setAllUsers] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [userData, setUserData] = useState(null);

    const [deletePaymentRequestModal, setDeletePaymentRequestModal] = useState(false);

    useEffect(()=>{
            if(id) {
                getPaymentRequest();
            }
        },[id]);
    
    
        const getPaymentRequest = async () => {
            try {
              const response = await apiClient.get(`/b-payment-requests/${id}`);
              if(response?.data) {
                let data = response?.data;
                delete data.createdBy;
                setEditPaymentRequestForm(data);
              } else {
      
              }
            } catch(err) {

            }
          }

    const handleSubmitEditPaymentRequest = async () => {
        setIsEditPaymentRequestFormDisabled(true);
        const finalEditPaymentRequestForm = JSON.parse(JSON.stringify(editPaymentRequestForm));
        finalEditPaymentRequestForm.amount = parseInt(finalEditPaymentRequestForm.amount);
        if(finalEditPaymentRequestForm?.isRecurring === false) {
            delete finalEditPaymentRequestForm.recurrence;
        }
        try {
        const response = await apiClient.post(`/b-payment-requests`,finalEditPaymentRequestForm);
        if(response?.data || response?.status === 201) {
            navigate(`/ar/payment-requests`);
        } else {
            setIsEditPaymentRequestFormDisabled(false);
        }
        } catch(err) {
            setIsEditPaymentRequestFormDisabled(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
            if(err?.response?.data?.meta?.response?.message) {
                setToast({show:true,type:'error',message:err?.response?.data?.meta?.response?.message})
            }
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }


    useEffect(()=>{
        if(editPaymentRequestForm 
            && editPaymentRequestForm?.title && editPaymentRequestForm?.title !== ''
            && editPaymentRequestForm?.description && editPaymentRequestForm?.description !== ''
            && editPaymentRequestForm?.beneficiaryIds && Array.isArray(editPaymentRequestForm?.beneficiaryIds) && editPaymentRequestForm?.beneficiaryIds?.length > 0
            && editPaymentRequestForm?.dueDate && editPaymentRequestForm?.dueDate !== ''
            && editPaymentRequestForm?.isRecurring !== ''
            ) {
                setIsEditPaymentRequestFormDisabled(false);
                if(editPaymentRequestForm?.isRecurring) {
                    if(editPaymentRequestForm?.recurrence?.frequency && editPaymentRequestForm?.recurrence?.frequency !== ''
                        && editPaymentRequestForm?.recurrence?.repeat && editPaymentRequestForm?.recurrence?.repeat !== '') {
                            setIsEditPaymentRequestFormDisabled(false);
                        } else {
                            setIsEditPaymentRequestFormDisabled(true);
                        }
                }  else {
                    setIsEditPaymentRequestFormDisabled(false);
                }
        } else {
            setIsEditPaymentRequestFormDisabled(true);
        }
    },[editPaymentRequestForm])


    const useRolesOptions = [
        {label:'المدراء', value:'ADMINISTRATOR'},
        {label:'الموظفين', value:'EMPLOYEE'},
        {label:'المستفيدين', value:'BENEFICIARY'}
    ]

    const getAllUsers = async () => {
      try {
        const response = await apiClient.get(`/b-users`);
        if(response?.data) {
          setAllUsers(response?.data?.filter(user =>  user?.role?.id === 'BENEFICIARY').map(user => ({label: user?.name, value: user?._id})));
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        getAllUsers();
    },[])



    const TrueOrFalseOptions = [
        {label:'نعم', value: true},
        {label:'لا', value: false},
    ]

    const frequencyOptions = [
        {label:'أسبوعي', value: 'weekly'},
        {label:'شهري', value: 'monthly'},
        {label:'ربع سنوي', value: 'quarterly'},
        {label:'نصف سنوي', value: 'semi-annually'},
        {label:'سنوي', value: 'yearly'},
    ]

    const EndAfterOptions = [
        {label:'2 مرة', value: 2},
        {label:'3 مرة', value: 3},
        {label:'4 مرة', value: 4},
        {label:'5 مرة', value: 5},
        {label:'6 مرة', value: 6},
        {label:'7 مرة', value: 7},
        {label:'8 مرة', value: 8},
        {label:'9 مرة', value: 9},
        {label:'10 مرة', value: 10},
        {label:'11 مرة', value: 11},
        {label:'12 مرة', value: 12}
    ]

    const handleGetUser = (user) => {
        setUserData(user);
        setEditPaymentRequestForm({ ...editPaymentRequestForm, createdBy: user?._id });
    }
    
    const handleSubmitDeleteِPaymentRequest = () => {
        setDeletePaymentRequestModal(true);
    }


    const handleCloseModalDelete = () => {
        setDeletePaymentRequestModal(false);
    }

    const handleSubmitDeletePaymentRequsetAction = async () => {
        try {
            const response = await apiClient.delete(`b-payment-requests/${id}`);
            if(response?.data || response?.status === 204 || response?.status === 200) {
                navigate(`/ar/payment-requests`);
            } else {
                setIsEditPaymentRequestFormDisabled(false);
            }
        } catch(err) {setIsEditPaymentRequestFormDisabled(false);}
    }

    return (
        <div>
        <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
        <PageMain>
            <span className="absolute top-0 left-0 right-0 bottom-0 z-0 bg-grey-50"></span>
            <MainContent>
                <NormalFormContainer heading="من فضلك قم بملئ البيانات التالية لإرسال تعديل أمر الدفع." label="تعديل أمر الدفع ">
                    
                    <div className="mb-[15px]">
                        <InputField label={'عنوان أمر الدفع'} placeholder={'اكتب عنوان أمر الدفع'} value={editPaymentRequestForm?.title} error={errors?.title} errorMessage={errors?.title} translateError={true} onChange={(e)=>{setEditPaymentRequestForm({ ...editPaymentRequestForm, title: e.target.value }); hideError('title')}} />
                    </div>

                    <div className="mb-[15px] relative">
                        <InputField label={'المبلغ'} placeholder={'اكتب المبلغ هنا'} value={editPaymentRequestForm?.amount} error={errors?.amount} errorMessage={errors?.amount} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setEditPaymentRequestForm({ ...editPaymentRequestForm, amount: e.target.value }) }; hideError('amount')}} />
                        <span className="absolute top-[41px] end-[15px] w-[13px] h-[13px]" style={{background:"url('/assets/images/SAR-mini.svg')"}}></span>
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'السبب'} placeholder={'اكتب سبب أمر الدفع هنا ان وجد'} value={editPaymentRequestForm?.description} error={errors?.description} errorMessage={errors?.description} translateError={true} onChange={(e)=>{setEditPaymentRequestForm({ ...editPaymentRequestForm, description: e.target.value }); hideError('description')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'اسماء المستفيدين'} placeholder={'اختر أسماء المستفيدين هنا'} isMulti options={allUsers} error={errors?.beneficiaryIds} errorMessage={errors?.beneficiaryIds} value={editPaymentRequestForm?.beneficiaryIds} onChange={(options)=>{setEditPaymentRequestForm({ ...editPaymentRequestForm, beneficiaryIds: options?.map(option => option?.value) }); hideError('beneficiaryIds')}} />
                    </div>

                    <div className="mb-[15px]">
                        <DateField label={'تاريخ الاستحقاق'} today placeholder={'اكتب تاريخ الاستحقاق هنا'} value={editPaymentRequestForm?.dueDate} error={errors?.dueDate} errorMessage={errors?.dueDate} translateError={true} onChange={(date)=>{ setEditPaymentRequestForm({ ...editPaymentRequestForm, dueDate: date, installationDate: date }); hideError('dueDate')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'التكرار'} placeholder={'اختر إذا كان أمر الدفع سيكرر أم لا '} options={TrueOrFalseOptions} error={errors?.isRecurring} errorMessage={errors?.isRecurring} value={editPaymentRequestForm?.isRecurring} onChange={(option)=>{setEditPaymentRequestForm({ ...editPaymentRequestForm, isRecurring: option?.value }); hideError('isRecurring')}} />
                    </div>

                    {editPaymentRequestForm?.isRecurring && <>
                        <div className="mb-[15px]">
                            <MultiSelect label={'معدل التكرار'} placeholder={'اختر معدل التكرار '} options={frequencyOptions} error={errors?.frequency} errorMessage={errors?.recurrence?.frequency} value={editPaymentRequestForm?.recurrence?.frequency} onChange={(option)=>{setEditPaymentRequestForm({ ...editPaymentRequestForm, recurrence: { ...editPaymentRequestForm.recurrence, frequency: option?.value } }); hideError('frequency')}} />
                        </div>

                        <div className="mb-[15px]">
                            <MultiSelect label={'ينتهي بعد'} placeholder={'اختر عدد مرات التكرار '} options={EndAfterOptions} error={errors?.endAfter} errorMessage={errors?.recurrence?.repeat} value={editPaymentRequestForm?.recurrence?.repeat} onChange={(option)=>{setEditPaymentRequestForm({ ...editPaymentRequestForm,  recurrence: { ...editPaymentRequestForm.recurrence, repeat: option?.value }}); hideError('endAfter')}} />
                        </div>

                    </>}



                    

                    <div className="text-end">
                        <NormalButton color={'!bg-danger'} label={'حذف أمر الدفع'} onClick={handleSubmitDeleteِPaymentRequest} isDisabled={false} gabEnd={true} />
                        <NormalButton label={'تعديل'} onClick={handleSubmitEditPaymentRequest} isDisabled={isEditPaymentRequestFormDisabled} />
                    </div>

                </NormalFormContainer>
            </MainContent>
        </PageMain>



        { deletePaymentRequestModal && <ModalContainer heading="حذف أمر الدفع" handleCloseModal={handleCloseModalDelete}>
                    <p className="text-[16px] text-grey-900 leading-[24px] font-[400]">هل أنت متأكد من حذف أمر الدفع؟</p>
                    <div className="text-end">
                        <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleCloseModalDelete}>إلغاء</div>
                        <NormalButton color={'!bg-danger'} label={'حذف أمر الدفع'} onClick={handleSubmitDeletePaymentRequsetAction} isDisabled={false} />
                    </div>
                </ModalContainer> }


                <Toast toast={toast} setToast={setToast} />
        </div>
    )

}

export default PaymentRequestsEditPage;